import { $, T } from "../../common/drupal/drupal";

class InstagramSocialWall {

    /**
     * Initialize event listeners
     */
    init() {
        const isSwiperOn = document.querySelector('.swiperInstaMobile .swiper-container-initialized');
        if (!isSwiperOn) {
            const swiper = new Swiper('.swiperInstaMobile', {
                slidesPerView: 1,
                speed: 1000,
                centerInsufficientSlides: true,
                // watchOverflow: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                  el: ".swiper-pagination",
                  clickable: true,
                  renderBullet: function (index, className) {
                    return '<span class="' + className + '"></span>';
                  },
                },
            });
        }
    }

    attach(context) {
        this.init(context);
    }
}

export let instagramSocialWall = new InstagramSocialWall();
